import type { CanvasChatMessage } from '@/pages/canvas/canvas-types';
import { ChatToolProgressCard } from './ChatToolProgressCard';
import { PlaybookTaskCard } from './PlaybookTaskCard';

/** Phase events upgrade the same visible progress tile in place. */
export function CanvasRunProgressCard({ message, isActive }: { message: CanvasChatMessage; isActive: boolean }) {
  const hasImageGallery = message.imageSlots?.some(slot => !!slot.resolved)
    || (!message.imageSlots?.length && !!message.thumbnails?.length);
  return <div data-testid={`canvas-run-progress-${message.id}`}>
    {message.playbookProgress ? (
      <PlaybookTaskCard progress={message.playbookProgress} messageId={message.id}
        messageImageSlots={message.imageSlots} isActive={isActive}
        showThumbnails={!hasImageGallery} />
    ) : (
      <ChatToolProgressCard groups={message.agentTaskGroups ?? []} isStreaming={isActive} />
    )}
  </div>;
}
